<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('Sports')" :directory="$t('datatables')" :icon="'grid'"/>
        <app-table :id="'responsive-table'" :options="options"/>
    </div>
</template>

<script>
    import * as actions from "../../../Config/ApiUrl";
    import {TableHelpers} from "./mixins/TableHelpers";
    import { FormMixin } from "../../../../core/mixins/form/FormMixin.js";

    export default {
        name: "ResponsiveDatatable",
        mixins:[TableHelpers, FormMixin],
        data() {
            return {
                responsiveDatatableInstruction: [this.$t('datatable_responsive_note')],
                options: {
                    name: 'Responsive Table',
                    url: actions.BET_DATATABLE_DATA,
                    showHeader: true,
                    columns: [],
                    datatableWrapper: false,
                    showFilter: false,
                    showSearch: true,
                    showAction: true,
                    actions:[],
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 20,
                    orderBy: 'desc',
                }
            }
        },
        created(){
            this.options.columns = [...this.tableColumns];
        },
    }
</script>
